var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7097 22.8888C18.7097 21.4161 19.9228 20.2222 21.4193 20.2222H38.5806C40.0771 20.2222 41.2903 21.4161 41.2903 22.8888V43.3333C41.2903 44.806 40.0771 45.9999 38.5806 45.9999H21.4193C19.9228 45.9999 18.7097 44.806 18.7097 43.3333V22.8888Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 34.4443C16 33.4625 16.8088 32.6666 17.8065 32.6666H42.1935C43.1912 32.6666 44 33.4625 44 34.4443V40.6666C44 41.6484 43.1912 42.4443 42.1935 42.4443H17.8065C16.8088 42.4443 16 41.6484 16 40.6666V34.4443Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4838 26.4444C39.4838 28.4081 37.8663 30 35.8709 30L24.129 30C22.1336 30 20.5161 28.4081 20.5161 26.4444L20.5161 20.2222L22.3225 20.2222L22.3225 26.4444C22.3225 27.4263 23.1313 28.2222 24.129 28.2222L35.8709 28.2222C36.8686 28.2222 37.6774 27.4263 37.6774 26.4444L37.6774 20.2222L39.4838 20.2222L39.4838 26.4444Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0645 20.2222V19.7778C34.0645 17.5686 32.2448 15.7778 30 15.7778C27.7552 15.7778 25.9355 17.5686 25.9355 19.7778V20.2222H34.0645ZM30 14C26.7576 14 24.129 16.5868 24.129 19.7778V22H35.871V19.7778C35.871 16.5868 33.2424 14 30 14Z",
    fill: "#2F2F2F"
  })));
};
export default SvgBack;